import React, { useEffect, useState } from "react";
import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { db } from "../firebase";
import "./AdminPage.css";

export default function AdminPage() {
  const [regs, setRegs] = useState([]);
  const [eventsMap, setEventsMap] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        // Load events to map eventId -> title
        const eventsSnap = await getDocs(collection(db, "events"));
        const evMap = {};
        eventsSnap.docs.forEach((d) => {
          evMap[d.id] = d.data().title || "Untitled Event";
        });
        setEventsMap(evMap);

        // Load all registrations (most recent first)
        const regsSnap = await getDocs(
          query(collection(db, "registrations"), orderBy("timestamp", "desc"))
        );
        const list = regsSnap.docs.map((d) => ({ id: d.id, ...d.data() }));
        setRegs(list);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  return (
    <div className="admin-container">
      <h2>User Registrations Dashboard</h2>

      {loading ? (
        <div className="loading">Loading registrations...</div>
      ) : regs.length === 0 ? (
        <div className="no-registrations">No registrations yet.</div>
      ) : (
        <div className="registrations-list">
          {regs.map((r) => (
            <div key={r.id} className="registration-card">
              <div className="registration-info">
                <div className="reg-name">{r.name}</div>
                <div className="reg-email">{r.email}</div>
                <div className="reg-phone">Phone: {r.phone}</div>
                <div className="reg-event">Event: {eventsMap[r.eventId] ?? r.eventId}</div>
                <div className="reg-type">
                  Login Type: {r.userId ? "Google / Auth User" : "Form / Guest"}
                </div>
              </div>
              <div className="reg-timestamp">
                {r.timestamp?.toDate ? r.timestamp.toDate().toLocaleString() : ""}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
